import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const listItemCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}:host{--selected-color:#1ec95b;display:inline-block;position:relative;overflow:hidden;cursor:pointer;--webkit-user-drag:none}.selection-overlay,.hover-overlay{position:absolute;top:0;left:0;bottom:0;right:0;z-index:1;opacity:0}:host(:hover:not([disabled])) .hover-overlay,:host(:focus:not([disabled])) .hover-overlay{opacity:1}:host([selected]:not([disabled])) .selection-overlay{opacity:1}:host([disabled]){user-select:none;cursor:not-allowed}";

const ListItem = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.selected = false;
    this.value = undefined;
    this.disabled = false;
  }
  render() {
    return (h(Host, { role: "listitem", disabled: this.disabled, "aria-disabled": this.disabled ? 'true' : 'false', "aria-selected": this.selected ? 'true' : 'false', tabIndex: !this.disabled ? 0 : null, part: "base" }, h("div", { part: "hover-overlay", class: "hover-overlay" }), h("div", { part: "selection-overlay", class: "selection-overlay" }), h("slot", null)));
  }
  get element() { return this; }
  static get style() { return listItemCss; }
}, [1, "tt-list-item", {
    "selected": [516],
    "value": [520],
    "disabled": [516]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-list-item"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-list-item":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ListItem);
      }
      break;
  } });
}

const TtListItem = ListItem;
const defineCustomElement = defineCustomElement$1;

export { TtListItem, defineCustomElement };
